import React from 'react';

import { UiKit } from 'components';
import { useProductReturnWindowDelete } from '../context';

/**
 * @param {Object} props
 * @param {import('utils/types').ButtonVariant} props.variant
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function Trigger({ children = 'Delete' }) {
  const { isProcessing, onDelete } = useProductReturnWindowDelete();

  return (
    <UiKit.Button
      size="sm"
      variant="ghost-destructive"
      onClick={onDelete}
      processing={isProcessing}
    >
      {children}
    </UiKit.Button>
  );
}
